export * from "/app/node_modules/@sport1/bets-service-client/build/index.js"